

import { Component, Prop, toNative, Vue } from 'vue-facing-decorator';
import { VonageSessionData } from '@/entities/VonageSessionData';
import { VideoOnDemandMetrics, VodVideoMetricsRequest } from '@/entities/VodDetail';
import PreRecordedMeetingHighcharts from '@/components/Common/PreRecordedMeetingHighcharts.vue';
import VirtualMeetingSessionAnalytics from '@/components/Common/VirtualMeetings/VirtualMeetingSessionAnalytics.vue';
import { Root } from '@/main';
@Component({
  components: {
    PreRecordedMeetingHighcharts,
    VirtualMeetingSessionAnalytics,
  },
})
class VirtualMeetingCombineAnalytics extends Vue {
  @Prop() private vonageAnalyticsForGraph?: VonageSessionData;
  @Prop() private selectedProgramId?: number;
  @Prop() private videoDetail?: VodVideoMetricsRequest;
  @Prop() private videoOnDemandMetrics?: VideoOnDemandMetrics;
  @Prop() private streamType?: number;
  @Prop() private moduleType?: string;
  private isMobileView = false;
  private mounted() {
    if (window.innerWidth <= 767) {
      this.isMobileView = true;
    } else {
      this.isMobileView = false;
    }
    this.showDetailedSection();
    this.showConsolidatedSection();
  }
  private Cancel() {
    Root.emit('reload-program-detail');
    Root.emit('reload-watchlive-detail');
  }
  private showDetailedSection() {
    Root.emit('show-detailed-section', true);
  }
  private showConsolidatedSection() {
    Root.emit('show-consolidated-section', true);
  }
}
export default toNative(VirtualMeetingCombineAnalytics);
